// extracted by mini-css-extract-plugin
export default {"projectDescription":"ProjectDescription_projectDescription__Mjyvr"};